import { render, staticRenderFns } from "./B-5-2-1__CareerEdit_CompanyCulture.vue?vue&type=template&id=72a76f1c&"
import script from "./B-5-2-1__CareerEdit_CompanyCulture.vue?vue&type=script&lang=js&"
export * from "./B-5-2-1__CareerEdit_CompanyCulture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
